// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7c4c5dbc","228":"e305cbdd","233":"9b5a1acd","462":"2d7e9c82","570":"3c78da2f","685":"94fa683b","719":"dc67a963","779":"92fa4b57","877":"9bbf5c7c"}[chunkId] + ".chunk.js";
};